import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Breadcrumb from '../../components/Breadcrumb';
import EventMain from './EventMain';
import ScrollToTop from '../../components/ScrollTop';

import Logo from '../../assets/images/logos/logo2.png';


const Event = () => {
    return (
      <body class="event-page">
        <Header
          parentMenu="event"
          menuCategoryEnable="enable"
          headerNormalLogo={Logo}
          headerStickyLogo={Logo}
          topbarEnable="enable"
        />

        <div class="react-wrapper">
          <div class="react-wrapper-inner">
            <Breadcrumb pageTitle="Event" />

            <EventMain />

            {/* scrolltop-start */}
            <ScrollToTop />
            {/* scrolltop-end */}
          </div>
        </div>

        <Footer />
      </body>
    );
}


export default Event;

